/**
 * Created by yangyue on 2018/6/23.
 */
module.exports = {
  WXPAY_PROGRESS_NO_PAID: 10,
  WXPAY_PROGRESS_ORDERPAID: 11,
  WXPAY_PROGRESS_TRANSITION_SUCCESS: 12,

  // 登录日志
  ACCESS_LOGS_TO_TOKEN_AUTH: 1,
  ACCESS_LOGS_TO_TOKEN_EXPIRED: -1,

  PAGINATION: {
    currentPage: 1,
    pageSizes: [10, 15, 20]
  },

  PROGRESS: {
    NOT_PAID: 10,
    ORDERPAID: 11,
    TRANSITION_SUCCESS: 12,
    TRANSITION_FAILURE: -1,
  },

  // 商品类别
  PRODUCT_CATEGORY: [
    {label: '钻石', value: 0},
    {label: '房卡', value: 1},
    {label: '头像框', value: 2},
    {label: '互动道具', value: 3},
    {label: '胡牌特效', value: 4},
    {label: '入场动画', value: 5},
    {label: '桌布', value: 6},
    {label: '牌背', value: 7},
    {label: '出牌特效', value: 8},
    {label: '气泡', value: 9},
    {label: '晶石', value: 10},
  ],
  // 商品状态
  PRODUCT_STATUS: [
    {label: '正常', value: 0},
    {label: '火爆', value: 1},
    {label: '推荐', value: 2},
    {label: '打折', value: 3}
  ],

  // 出售货币类型
  SELL_TYPE: [
    {label: 'RMB', value: 0},
    {label: '钻石', value: 1},
  ],

  /**
   * 与App 签名秘钥
   */
  YUKE_APP_SECRET: 'u7HS6pZ0^ZGr9TpHBbj0',
};



// WEBPACK FOOTER //
// ./src/utils/constant.js